export const API_URL = process.env.REACT_APP_BACKEND_URL;
export const PHONE = '0618481107';
export const PHONE_DISPLAY = '06 18 48 11 07';

export const TYPE_LABELS = {
  voilier: 'Voilier', moteur: 'Bateau à moteur', multicoque: 'Multicoque', 'semi-rigide': 'Semi-rigide', classique: 'Bateau classique', autre: 'Autre',
};
export const STATUS_LABELS = {
  draft: 'Brouillon', available: 'Disponible', under_offer: 'Sous offre', reserved: 'Réservé', sold: 'Vendu', archived: 'Archivé',
};
export const STATUS_STYLE = {
  available: 'bg-[#d9fb06] text-[#1a1c1b]', under_offer: 'bg-orange-400 text-[#1a1c1b]', reserved: 'bg-purple-300 text-[#1a1c1b]',
  sold: 'bg-[#888680] text-[#1a1c1b]', draft: 'bg-[#302f2c] text-[#dfddd6] border border-[#3f4816]', archived: 'bg-[#302f2c] text-[#888680]',
};
export const PROGRAM_LABELS = {
  premier_bateau: 'Premier bateau', journee: 'Sorties à la journée', cotier: 'Navigation côtière', croisiere_familiale: 'Croisière familiale',
  grande_croisiere: 'Grande croisière', vie_a_bord: 'Vie à bord', solitaire: 'Navigation en solitaire', peche_promenade: 'Pêche-promenade', transportable: 'Bateau transportable',
};
export const DOC_LEVEL_LABELS = { basique: 'Documentation de base', intermediaire: 'Bien documenté', complet: 'Très documenté' };
export const PASSPORT_STATUS = {
  verifie: { label: 'Document vérifié', cls: 'bg-green-500/20 text-green-300 border-green-500/40' },
  declare: { label: 'Déclaré par le vendeur', cls: 'bg-blue-500/20 text-blue-300 border-blue-500/40' },
  observe: { label: 'Observé par ValidatedBoat', cls: 'bg-[#d9fb06]/20 text-[#d9fb06] border-[#d9fb06]/40' },
  analyse_photos: { label: 'Analysé sur photos / vidéos', cls: 'bg-cyan-500/20 text-cyan-300 border-cyan-500/40' },
  a_controler: { label: 'À contrôler lors de la visite', cls: 'bg-yellow-500/20 text-yellow-300 border-yellow-500/40' },
  expertise_recommandee: { label: 'Expertise professionnelle recommandée', cls: 'bg-orange-500/20 text-orange-300 border-orange-500/40' },
  non_communique: { label: 'Information non communiquée', cls: 'bg-[#302f2c] text-[#888680] border-[#3f4816]' },
};
export const PASSPORT_CATEGORIES = {
  identite: 'Identité du bateau', documents: 'Documents administratifs', entretien: "Historique d'entretien", etat_visuel: 'État visuel',
  motorisation: 'Motorisation', greement: 'Gréement et voiles', electricite: 'Électricité et électronique', prix: 'Cohérence du prix',
  travaux: 'Travaux connus', verifications: 'Vérifications complémentaires recommandées',
};
export const SPEC_SECTIONS = {
  generalites: 'Généralités', dimensions: 'Dimensions', coque: 'Coque et pont', motorisation: 'Motorisation', greement: 'Gréement et voiles',
  electricite: 'Électricité', electronique: 'Électronique', interieur: 'Aménagement intérieur', confort: 'Confort', securite: 'Sécurité',
};
export const TRANSPARENCY_TEXTS = {
  accompagnement_vendeur: "Cette annonce est présentée dans le cadre d'un accompagnement confié par le vendeur. Les informations vérifiées, déclarées et restant à contrôler sont identifiées séparément. Une inspection, un diagnostic mécanique ou une expertise maritime complémentaire peut être recommandé avant l'achat.",
  selection: "Cette annonce a été sélectionnée par ValidatedBoat pour sa cohérence et la qualité des informations disponibles, sans mandat du vendeur. Les informations vérifiées, déclarées et restant à contrôler sont identifiées séparément. Une inspection ou une expertise complémentaire peut être recommandée avant l'achat.",
  observe: "ValidatedBoat a observé ce bateau sur place. Cette observation visuelle n'est ni un diagnostic mécanique ni une expertise maritime : les informations vérifiées, déclarées et restant à contrôler sont identifiées séparément.",
  expertise_independante: "Une expertise maritime indépendante a été réalisée sur ce bateau par un professionnel tiers ; son rapport est mentionné dans les documents disponibles. Les autres informations vérifiées, déclarées et restant à contrôler sont identifiées séparément.",
  vendeur_seul: "Les informations de cette annonce proviennent uniquement du vendeur et n'ont pas encore été vérifiées par ValidatedBoat. Elles sont identifiées comme déclarées. Une visite, un diagnostic mécanique ou une expertise maritime sont recommandés avant tout engagement.",
};

export const fmtPrice = (p) => (p == null ? null : new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(p));
export const fmtDate = (iso) => (iso ? new Intl.DateTimeFormat('fr-FR', { dateStyle: 'medium' }).format(new Date(iso)) : null);
export const boatTitle = (b) => [b.brand, b.model, b.version].filter(Boolean).join(' ');
export const isNew = (b) => b.published_at && Date.now() - new Date(b.published_at).getTime() < 30 * 86400000;
export const imgUrl = (u) => (u && u.startsWith('/') ? `${API_URL}${u}` : u);

export const track = (event, props = {}) => {
  try {
    if (window.posthog?.capture) window.posthog.capture(event, props);
  } catch { /* noop */ }
};
export const boatEvent = (boatId, type) => {
  if (!boatId) return;
  fetch(`${API_URL}/api/boats/${boatId}/event`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ type }) }).catch(() => {});
};

const FAV_KEY = 'vb_boat_favorites';
export const getFavorites = () => { try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch { return []; } };
export const toggleFavorite = (id) => {
  const f = getFavorites();
  const next = f.includes(id) ? f.filter((x) => x !== id) : [...f, id];
  localStorage.setItem(FAV_KEY, JSON.stringify(next));
  return next;
};

const CMP_KEY = 'vb_boat_compare';
export const getCompare = () => { try { return JSON.parse(localStorage.getItem(CMP_KEY) || '[]'); } catch { return []; } };
export const toggleCompare = (slug) => {
  const c = getCompare();
  let next;
  if (c.includes(slug)) next = c.filter((x) => x !== slug);
  else if (c.length >= 3) return { list: c, full: true };
  else next = [...c, slug];
  localStorage.setItem(CMP_KEY, JSON.stringify(next));
  window.dispatchEvent(new Event('vb-compare-change'));
  return { list: next, full: false };
};
